import React, { useEffect, useState } from "react";
import "./settings.scss";
import { Avatar, Button, Col, Divider, Input, Row, Typography } from "antd";
import {
  ConfigMapKey,
  GetConfigMapRes,
  UpdateConfigMapReq,
} from "../../../../interfaces/configMap.interface";
import { HandleErrors } from "../../../../utils/handleErrors";
import { getAllConfigMapService, updateConfigMapService } from "../../../../services/configmap.service";
import { toast } from "react-toastify";
import { useSelector } from "react-redux";
import { RootState } from "../../../../redux/store";
import { GetPermissionRes } from "../../../../interfaces/role.interface";
import { PermissionCode } from "../../../../enum/permission";

const Setting = () => {
  const userPermissions = useSelector<RootState, GetPermissionRes[]>(
    (root) => root.user.permissions
  );
  const health = useSelector<RootState, string>(
    (root) => root.app.health
  )

  const [loading, setLoading] = useState(0);

  const [configs, setConfigs] = useState<GetConfigMapRes[]>([]);

  useEffect(() => {
    getConfigs();
  }, []);

  const getConfigs = async () => {
    try {
      const res = await getAllConfigMapService({});
      setConfigs(res.list);
    } catch (error) {
      HandleErrors(error);
    }
  };


  const update = async (data: UpdateConfigMapReq)=>{
    try {

      if(!data.value){
        toast.error('مقدار را وارد کنید');
        return;
      }

      setLoading(data.id)
      const res = await updateConfigMapService(data);
      toast.success("تغییرات با موفقیت ثبت شد")
      setLoading(0);

      if(data.key == ConfigMapKey.license){
        window.location.reload();
      }
    } catch (error) {
      HandleErrors(error);
      setLoading(0);
    }
  }


  return (
    <div className="OrganizationSetting">
      <Row align={"middle"} justify={"start"} className="title-box">
        <Col>
          <Typography.Text className="title">تنظیمات سازمان</Typography.Text>
        </Col>
      </Row>

      {configs.map((item, index) => {
        if (
          item.key === ConfigMapKey.organizationLogo ||
          item.key === ConfigMapKey.organizationName
        ) {
          return <></>;
        }

        return (
          <div className="info-box">
            <Row>
              <Col>
                <Typography.Text className="title">{item.name}</Typography.Text>
              </Col>
            </Row>
            <Row align={"middle"} justify={"start"}>
              <Col>
                <Typography.Text className="desc">
                  {item.key == ConfigMapKey.license && health == 'license-false' ? 'لایسنس خود را وارد کنید' : item.description}
                </Typography.Text>
              </Col>
            </Row>
            <Divider />
            <Row justify={"space-between"} align={"bottom"}>
              <Col md={21} xs={18} className="input-box">
                <Input
                  className="input"
                  suffix={item.key == ConfigMapKey.license && health == 'license-false' ? '' : item.unit}
                  value={ item.value}
                  onChange={(e)=>{
                    const t = [...configs];
                    t[index].value = e.target.value;
                    setConfigs(t);
                  }}
                />
              </Col>
              <Col md={3} xs={5} className="btn-box">
                {userPermissions.find(p => p.code === PermissionCode.updateConfigMap) && <Button disabled={item.key == ConfigMapKey.license && health != 'license-false' ? true : false} loading={loading === item.id} onClick={()=>{
                  update(item)
                }} type="primary" block className="btn">
                  ذخیره
                </Button>}
              </Col>
            </Row>
          </div>
        );
      })}
    </div>
  );
};

export default Setting;
